import { Component, Input } from '@angular/core';
import { FormGroup, FormArray, FormControl, AbstractControl } from '@angular/forms';

import { DescriptorFormControl } from '../../descriptor/descriptor-form-control';
import { FormService } from '../../services/form.service';

@Component({
  selector: 'vedrax-matrix',
  templateUrl: './vedrax-matrix.component.html',
  styleUrls: ['./vedrax-matrix.component.scss']
})
export class VedraxMatrixComponent {

  @Input() form: FormGroup = new FormGroup({});
  @Input() descriptor: DescriptorFormControl = new DescriptorFormControl();

  constructor(private formService: FormService) { }

  /**
   * Get declared array of controls
   */
  get formArray(): FormArray {
    return this.form.get(this.descriptor.controlName) as FormArray;
  }

  getChildControl(control: AbstractControl, controlName: string = ''): FormControl {
    return this.formService.getComponent(control, controlName);
  }

  getChildControls(control: AbstractControl, controlName: string = ''): FormArray {
    return this.formService.getComponents(control, controlName);
  }

  getControlValue(control: AbstractControl, controlName: string = ''): any {
    const ctrl = this.formService.getComponent(control, controlName);
    if (ctrl) {
      return ctrl.value;
    }
    return undefined;
  }

}
